import { createContext, useState } from 'react';

const PreviewDataContext = createContext();
const PreviewContextProvider = ({ children }) => {
    const [preview, setPreview] = useState(null);
    return (
        <PreviewDataContext.Provider value={{ preview, setPreview }}>
            {children}
        </PreviewDataContext.Provider>
    );
};

export { PreviewDataContext, PreviewContextProvider };
